import { Component, signal, ViewChild } from "@angular/core";
import { Location } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { MatSidenav, MatDrawerContent, MatDrawerContainer, MatDrawer } from "@angular/material/sidenav";
import { AuthService } from "../service/auth.service";
import { GeneralService } from "../service/general.service";
import { User } from "../entity/User";
import { Subscription } from "rxjs";
import { FooterComponent } from "./incs/footer.component";
import { LoaderComponent } from "./loader.component";

@Component({
    selector: "kilowant-app",
    templateUrl: "../../html/index.html",
    imports: [MatDrawerContainer, MatDrawer, MatDrawerContent, RouterOutlet, FooterComponent, LoaderComponent]
})
export class AppComponent {
    title = "Kilowant.com";

    user = signal<User | null>(null);
    isSupplier = signal<boolean>(false);
    isAdmin = signal<boolean>(false);
    hasAccount = signal<boolean>(false);
    loginSubscription: Subscription;
    clientSubscription: Subscription;
    clientSelected = signal<boolean>(false);

    initLoaded = signal<boolean>(false);

    @ViewChild("sidenav") public sidenav: MatSidenav = null!;
    @ViewChild("pageContent") pageContent: MatDrawerContent;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private generalService: GeneralService,
        private location: Location) {

        this.loginSubscription = authService.loginActivities$.subscribe(
            isLogin => {
                this.isAdmin.set(this.authService.isAdminToken());
                if (!this.isAdmin() && isLogin) {
                    this.loadUser();
                } else {
                    this.user.set(null);
                    this.redirectAdminToAdminArea();
                }
            });

        this.clientSubscription = this.generalService.changeClientActivities$.subscribe(
            client => {
                if (client != null) {
                    this.clientSelected.set(true);
                }
            });

    }

    ngOnInit(): void {
        this.isAdmin.set(this.authService.isAdminToken());
        this.setUser();
        this.redirectAdminToAdminArea();
    }

    setUser(): void {
        if (!this.isAdmin()) {
            this.generalService.changeIsPreRegisterSource$.subscribe(
                u => { this.user.set(u); }
            );
            this.checkAccountRequest();
            if (this.authService.isLoggedIn()) {
                this.loadUser();
            } else if (this.authService.isLoggedIn() == null) {
                this.authService.checkSession().subscribe(res => {
                    if (res) {
                        this.loadUser();
                    }
                })
            } else {
                this.checkAuthRequest();
            }
        } else {
            this.initLoaded.set(true);
        }
    }

    loadUser(): void {
        this.generalService.getDetails()
            .then(u => {
                if (u == null) {
                    this.checkAuthRequest();
                    return;
                }
                this.user.set(u);
                if (this.user() != null && this.user()!.isSupplier != null) {
                    this.isSupplier.set(this.user()!.isSupplier!);
                    this.hasAccount.set(this.generalService.getStoredAccount() != null);
                    this.generalService.changeAccountActivities$.subscribe(
                        account => {
                            this.hasAccount.set(account != null);
                        });
                }
                if (this.user()?.isAdvisor) {
                    this.clientSelected.set(this.generalService.getStoredClient() != null);
                }
                this.initLoaded.set(true);
            });
    }

    checkAccountRequest(): void {
        this.route.queryParams.subscribe((params: any) => {
            let account = params["account"];
            if (account != null) {
                this.generalService.storeInSession("defaultAccount", account);
            }
        });
    }

    checkAuthRequest(): void {
        this.route.queryParams.subscribe((params: any) => {
            let auth = params["auth"];

            if (auth != null) {
                this.authService.checkAuth(auth).subscribe((res: any) => {
                    this.generalService.storeInSession("loginEmail", res);
                    this.authService.authActivity(res);
                    this.initLoaded.set(true);
                });
            } else {
                this.initLoaded.set(true);
            }
        });
    }

    ngAfterViewInit(): void {
        this.generalService.setSidenav(this.sidenav);
        this.generalService.setPageContent(this.pageContent);
    }

    ngOnDestroy() {
        if (this.loginSubscription != null) {
            this.loginSubscription.unsubscribe();
        }
        if (this.clientSubscription != null) {
            this.clientSubscription.unsubscribe();
        }
    }

    redirectAdminToAdminArea(): void {
        if (this.isAdmin() && !this.location.path().startsWith("/admin-kilowant-area")) {
            this.router.navigate(["/admin-kilowant-area/dashboard"]);
        }
    }

    goto(url: string): void {
        this.generalService.closeSidenav();
        this.router.navigate([url]);
    }

    close(): void {
        this.generalService.closeSidenav();
    }

}
